import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
} from "@mui/material";
import Circle from "@mui/icons-material/Circle";

import "./ActionsDrawer.css";

const DrawerListItem = (items) =>
  items.map((item) => (
    <ListItem key={item.name} disablePadding>
      <ListItemButton onClick={item.action}>
        <ListItemIcon>
          <Circle />
        </ListItemIcon>
        <ListItemText primary={item.name} />
      </ListItemButton>
    </ListItem>
  ));

const ActionsDrawer = ({ isOpen, toggleDrawer, actions, myItems }) => {
  const DrawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
    >
      <List>{DrawerListItem(actions)}</List>
      <Divider />
      <List>
        <List>{DrawerListItem(myItems)}</List>
      </List>
    </Box>
  );

  return (
    <Drawer open={isOpen} onClose={() => toggleDrawer(false)}>
      {DrawerList}
    </Drawer>
  );
};

export default ActionsDrawer;
